import React from 'react';

export default function EmployeeSidebar({ employees, selectedEmpId, onSelect }) {
  return (
    <div className="rounded-xl shadow-sm border mb-4 bg-white">
      <div className="bg-gray-800 text-white px-4 py-3 rounded-t-xl">
        <h6 className="text-sm font-semibold">Employees</h6>
      </div>
      <div className="divide-y">
        <button
          onClick={() => onSelect(null)}
          className={`w-full text-left px-4 py-2 text-sm hover:bg-gray-100 transition ${
            !selectedEmpId ? 'bg-blue-100 font-semibold text-blue-800' : ''
          }`}
        >
          All Employees
        </button>
        {employees.map((emp) => (
          <button
            key={emp.id}
            onClick={() => onSelect(emp.id)}
            className={`w-full text-left px-4 py-2 text-sm hover:bg-gray-100 transition ${
              selectedEmpId === emp.id ? 'bg-blue-100 font-semibold text-blue-800' : ''
            }`}
          >
            {emp.full_name}
          </button>
        ))}
      </div>
    </div>
  );
}
